export const setRoute = (route, params = {}, title) => ({
  type: 'SET_ROUTE',
  route,
  title,
  ...params,
});
